var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4167 12.2708C18.4167 14.457 16.6445 16.2292 14.4583 16.2292C13.7498 16.2292 13.084 16.0431 12.5085 15.7166C11.8989 15.3711 11.3919 14.8701 11.0391 14.2648C10.6863 13.6595 10.5002 12.9715 10.5 12.2708C10.5 11.2543 10.8832 10.3273 11.5125 9.62667C11.8834 9.21261 12.3375 8.88151 12.8451 8.65505C13.3527 8.42859 13.9025 8.31186 14.4583 8.3125C16.6445 8.3125 18.4167 10.0846 18.4167 12.2708Z",
    stroke: "#213958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.458 4.75V8.3125C13.9022 8.31186 13.3524 8.42859 12.8448 8.65505C12.3372 8.88151 11.8831 9.21261 11.5122 9.62667C10.859 10.3523 10.4982 11.2945 10.4997 12.2708C10.4999 12.9715 10.6859 13.6595 11.0388 14.2648C11.3916 14.8701 11.8986 15.3711 12.5081 15.7166C11.4544 16.0352 10.0555 16.2292 8.52051 16.2292C5.24142 16.2292 2.58301 15.3429 2.58301 14.25V4.75",
    stroke: "#213958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58301 11.083C2.58301 12.1759 5.24142 13.0622 8.52051 13.0622C9.23578 13.0622 9.92176 13.0202 10.5567 12.9426M2.58301 7.91634C2.58301 9.00924 5.24142 9.89551 8.52051 9.89551C9.61142 9.89551 10.6339 9.79734 11.5122 9.62634M14.458 10.2913L13.2705 11.8747L15.6455 12.6663L14.458 14.2497M14.458 4.74967C14.458 5.84257 11.7996 6.72884 8.52051 6.72884C5.24142 6.72884 2.58301 5.84257 2.58301 4.74967C2.58301 3.65678 5.24142 2.77051 8.52051 2.77051C11.7996 2.77051 14.458 3.65678 14.458 4.74967Z",
    stroke: "#213958",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.76cb1ab81a3d3b051b1e13547df10930.svg";
export { ForwardRef as ReactComponent };